<script lang="ts">
    import { getProductPrice } from "../../../../api/hooks/lib/ssr"
    import { baseURL, companyName } from "../../configs/config"
    import { initialLocale, langField } from "../../i18n"
    let { product }: { product: TProduct } = $props()
</script>

<svelte:head>
    <link rel="canonical" href={`${baseURL}/${initialLocale}/product/${product.code}_${product.slug[initialLocale]}`} />
    <meta property="product:brand" content={companyName} />
    <meta property="product:name" content={langField(product.name)} />
    <meta property="product:price:amount" content={String(getProductPrice(product, false))} />
    <meta property="product:price:currency" content="EUR" />
</svelte:head>
